import { render, staticRenderFns } from "./ViewAllMyAnnouncement.html?vue&type=template&id=059af0f8&scoped=true&"
import script from "./ViewAllMyAnnouncement.vue?vue&type=script&lang=js&"
export * from "./ViewAllMyAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllMyAnnouncement.scss?vue&type=style&index=0&id=059af0f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059af0f8",
  null
  
)

export default component.exports